export const collection = {
  labels: {
    collection: "Coleção",
    collections: "Coleções",
    code: "Código",
    description: "Descrição",
    edit_collection: "Editar Coleção",
    name: "Nome",
    slug: "Slug",
    is_main: "Modelo Principal",
    is_official: "Modelo Oficial",
    platform: "Plataforma",
    platforms: "Plataformas",
    infos: "Informações",
    manufacturers: "Fabricantes",
    regions: "Regiões",
    franchises: "Franquias",
    details: "Detalhes",
    releases: "Lançamentos",
    genders: "Gêneros",
    medias: "Mídias",
    audio: "Áudio",
    subtitle: "Legenda",
    interface: "Interface",
    console: "Console",
    consoles: "Consoles",
    game: "Jogo",
    games: "Jogos",
    accessorie: "Acessório",
    accessories: "Acessórios",
    related: "Relacionados",
    versions: "Versões",
    version_this_console: "Lançados neste console",
    version_other_systems: "Lançados em outros sistemas",
    version_compilation: "Lançados em coletâneas",
    version_console_memory: "Presentes na memória de consoles",
    version_unofficial_other_systems:
      "Não-oficiais lançadas em outros sistemas",
    language: "Idioma",
    languages: "Idiomas",
    type_collection: "Tipo de Coleção",
    release_year: "Ano de Lançamento",
    release_date: "Data de Lançamento",
    image: "Imagem",
    images: "Imagens",
    add_gallery: "Adicionar Galeria",
    gallery: "Galeria",
    galleries: "Galerias",
    other_names: "Outros Nomes",
    tags: "Tags",
  },
  placeholders: {
    code: "Exe: BR",
    description: "Informe a descrição",
    name: "Informe o nome",
    slug: "Exe: nome-da-url",
  },
  modals: {
    titles: {
      add_collection: "Adicionar Coleção",
      add_gallery: "Adicionar Galeria",
      add_game: "Adicionar Jogo",
      add_accessory: "Adicionar Acessório",
      add_console: "Adicionar Console",
      add_related: "Relacionar Consoles",
      add_related_game: "Relacionar Jogos",
      add_related_accessory: "Relacionar Acessórios",
      add_version: "Adicionar Versão",
      del_game: "Excluir Jogo",
      copy_collection: "Copiar Coleção",
      edit_collection: "Editar Coleção",
      edit_gallery: "Editar Galeria",
      del_collection: "Excluir Coleção",
      del_gallery: "Excluir Galeria",
      del_image: "Excluir Imagem",
      del_accessory: "Excluir Acessório",
      del_console: "Excluir Console",
      del_related: "Excluir Relacionamento",
      del_version: "Excluir Versão",
    },
    messages: {
      copy_collection: "Você deseja COPIAR a coleção <strong>{name}</strong>?",
      del_gallery:
        "Você deseja EXCLUIR a galeria <strong>{name}</strong>?<br/>Todos as imagens desta coleção serão excluídas.",
      del_collection:
        "Você deseja EXCLUIR a coleção <strong>{name}</strong>?<br/>Todos os relacionamentos desta coleção serão excluídos.",
      del_image:
        "Você deseja continuar com a exclusão da imagem?<br/>Esta operação nao pode ser desfeita.",
      del_game:
        "Você deseja EXCLUIR o jogo <strong>{name}</strong> da coleção?",
      del_accessory:
        "Você deseja EXCLUIR o acessório <strong>{name}</strong> da coleção?",
      del_console:
        "Você deseja EXCLUIR o console <strong>{name}</strong> da coleção?",
      del_related:
        "Você deseja EXCLUIR o console relacionado <strong>{name}</strong>?",
      del_related_game:
        "Você deseja EXCLUIR o jogo relacionado <strong>{name}</strong>?",
      del_related_accessory:
        "Você deseja EXCLUIR o acessório relacionado <strong>{name}</strong>?",
      del_version:
        "Você deseja EXCLUIR o item <strong>{name}</strong> desta lista?",
    },
  },
  texts: {
    empty_gallery: "Não há galerias cadastradas.",
    empty_items: "Não há itens cadastrados.",
    empty_images: "Não há imagens cadastradas.",
    no_images: "Nenhuma imagem encontrada.",
  },
};
